import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";
import { Button } from "@mui/material";
import { showAuthModal } from "store/application/application-action";
import { authModalTabs } from "store/application/application-state";

import "./NotAuthorizedPopup.scss";

export const NotAuthorizedPopup = (props: {
  onClose?: () => void;
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      props.onClose && props.onClose();
    };
  }, [props]);

  const onLogin = () => {
    props.onClose && props.onClose();
    dispatch(showAuthModal({ tab: authModalTabs.login }));
  };

  const onSignup = () => {
    props.onClose && props.onClose();
    dispatch(showAuthModal({ tab: authModalTabs.signup }));
  };

  const onReturn = () => {
    props.onClose && props.onClose();
  };

  return (
    <div className="notAuthorized">
      <div className="authBody">
        <h4>You must be logged in to upload content</h4>

        <Button
          className="loginButton"
          variant="contained"
          fullWidth
          onClick={onLogin}
        >Log in</Button>

        <Button
          className="signupButton"
          variant="contained"
          fullWidth
          onClick={onSignup}
        >Create an Account</Button>

        <NavLink to="/" onClick={onReturn}>Return Home</NavLink>
      </div>
    </div>
  );
};
